module.exports = __webpack_public_path__ + "assets/img/115@3x.d925df89.png";